import Select from "@/components/Select";
import React from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import { Channel, channelOptions } from "@/types";

export type ChannelCondition = {
  channel: Channel;
  comparator: Comparator;
};

export function ChannelEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const channelCondtion = JSON.parse(
    condition.data || "{}"
  ) as ChannelCondition;

  function update(data: ChannelCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  const validComparatorOptions: Record<string, string> = {
    equals: comparatorDefs.equals,
    notEquals: comparatorDefs.notEquals
  };

  return (
    <>
      <Select
        options={validComparatorOptions}
        value={channelCondtion.comparator}
        onChange={(v) => update({ ...channelCondtion, comparator: v })}
      />
      <Select<Channel>
        options={channelOptions}
        value={channelCondtion.channel}
        onChange={(v) => update({ ...channelCondtion, channel: v })}
      />
    </>
  );
}
